var action = 'acp_search_segment_request';
var axios = require('axios');
var deleteSegment = function (id) {
    var data = {
        _ajax_nonce: AC.ajax_nonce,
        action: action,
        list_screen: AC.list_screen,
        layout: AC.layout,
        id: id,
        method: 'delete',
    };
    return axios.post(ajaxurl, mapDataToFormData(data));
};
var retrieveSegments = function () {
    var data = {
        _ajax_nonce: AC.ajax_nonce,
        action: action,
        list_screen: AC.list_screen,
        layout: AC.layout,
        method: 'read',
    };
    return axios.post(ajaxurl, mapDataToFormData(data));
};
var shareSegment = function (name, nonce, layout) {
    var data = {
        _ajax_nonce: nonce,
        action: action,
        layout: layout,
        name: name,
        method: 'share',
    };
    return axios.post(ajaxurl, mapDataToFormData(data));
};
var createSegment = function (name, global, querystring, whitelisted, nonce, layout_id) {
    var data = {
        _ajax_nonce: nonce,
        action: action,
        layout: layout_id,
        method: 'create',
        name: name,
        global: global ? 1 : 0
    };
    var formData = mapDataToFormData(data);
    var whitelisted_qs = new URLSearchParams();
    whitelisted.forEach(function (k) {
        whitelisted_qs.append(k, '');
    });
    formData.append('query_string', querystring);
    formData.append('whitelisted_query_string', whitelisted_qs.toString());
    return axios.post(ajaxurl, formData);
};
var mapDataToFormData = function (data, formData) {
    if (formData === void 0) { formData = null; }
    if (!formData) {
        formData = new FormData();
    }
    Object.keys(data).forEach(function (key) {
        formData.append(key, data[key]);
    });
    return formData;
};
export { deleteSegment, retrieveSegments, createSegment };
